/**
 * @module manifest/panelLayout/barFamily
 * @description Config A：柱状图族面板布局
 */

import { ChartType, type TChartType } from '@dbl/core/chart';
import { type PanelTabLayout } from './types';

const barBasicGroups = [
  'DataLabel',
  'LegendColorSetting',
  'XAxisSetting',
  'YAxisSetting',
  'LegendSetting',
  'ChartSwitch',
] as const;

const stackBarBasicGroups = [
  'DataLabel',
  'LegendColorSetting',
  'StackedLimit',
  'XAxisSetting',
  'YAxisSetting',
  'LegendSetting',
  'ToolTipSetting',
] as const;

const horizontalBarBasicGroups = [
  'DataLabel',
  'LegendColorSetting',
  'XAxisSetting',
  'YAxisSetting',
  'LegendSetting',
] as const;

export const BAR_FAMILY_PANEL_LAYOUT: Partial<
  Record<TChartType, PanelTabLayout[]>
> = {
  [ChartType.Bar]: [{ id: 'basic', groups: barBasicGroups }],
  [ChartType.StackBar]: [{ id: 'basic', groups: stackBarBasicGroups }],
  [ChartType.PercentStackBar]: [{ id: 'basic', groups: stackBarBasicGroups }],
  [ChartType.HorizontalBarChart]: [
    { id: 'basic', groups: horizontalBarBasicGroups },
  ],
};

